import data from "../public/contact-tlds.json" with { type: "json" };

const topLevelDomains = new Set(data.tlds);

// Check spelling and the IANA-listed ending only. No DNS or mailbox lookup.
export function isValidDomainType(value) {
  const domain = value.toLowerCase();
  const labels = domain.split(".");
  return domain.length <= 253 && labels.length > 1
    && labels.every((label) => /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/.test(label))
    && topLevelDomains.has(labels.at(-1));
}
